import { Controller } from "@hotwired/stimulus"
import SignaturePad from "signature_pad"

export default class extends Controller {
  static targets = ["canvas", "input", "clearButton"]
  static values = {
    penColor: { type: String, default: "#000000" },
    backgroundColor: { type: String, default: "#ffffff" },
    defaultHeight: { type: Number, default: 200 }
  }

  connect() {
    this.resizeTimer = null
    this.observer = null
    this.initializeSignaturePad()
    this.setupResizeObserver()
    this.setCanvasSize()
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
    window.removeEventListener("resize", this.handleResize.bind(this))
    if (this.signaturePad) {
      this.signaturePad.off()
    }
    if (this.resizeTimer) {
      clearTimeout(this.resizeTimer)
    }
  }

  setupResizeObserver() {
    this.observer = new MutationObserver((mutations) => {
      this.handleResize()
    })

    this.observer.observe(this.canvasTarget.parentElement, {
      attributes: true,
      attributeFilter: ['style', 'class', 'width', 'height'],
      attributeOldValue: true,
      childList: false,
      subtree: false
    })

    window.addEventListener("resize", this.handleResize.bind(this))
  }

  handleResize() {
    if (this.resizeTimer) {
      clearTimeout(this.resizeTimer)
    }
    this.resizeTimer = setTimeout(() => {
      this.resizeCanvas()
    }, 100)
  }

  initializeSignaturePad() {
    this.signaturePad = new SignaturePad(this.canvasTarget, {
      penColor: this.penColorValue,
      backgroundColor: this.backgroundColorValue
    })

    if (this.inputTarget.value) {
      this.signaturePad.fromDataURL(this.inputTarget.value)
    }

    this.signaturePad.addEventListener("endStroke", () => {
      this.updateHiddenInput()
    })
  }

  setCanvasSize() {
    setTimeout(() => {
      this.resizeCanvas()
      requestAnimationFrame(() => this.resizeCanvas())
    }, 50)
  }

  resizeCanvas() {
    const canvas = this.canvasTarget
    const parent = canvas.parentElement
    const ratio = Math.max(window.devicePixelRatio || 1, 1)

    const displayWidth = parent.offsetWidth
    const displayHeight = this.defaultHeightValue

    canvas.style.width = `${displayWidth}px`
    canvas.style.height = `${displayHeight}px`

    canvas.width = displayWidth * ratio
    canvas.height = displayHeight * ratio

    const context = canvas.getContext('2d')
    context.scale(ratio, ratio)

    if (this.signaturePad) {
      const data = this.signaturePad.toData()
      this.signaturePad.clear()
      if (data && data.length > 0) {
        this.signaturePad.fromData(data)
      }
    }
  }

  updateHiddenInput() {
    if (this.signaturePad.isEmpty()) {
      this.inputTarget.value = ""
    } else {
      this.inputTarget.value = this.signaturePad.toDataURL("image/png")
    }
  }

  clear() {
    this.signaturePad.clear()
    this.inputTarget.value = ""
  }
}
